import { Component, Inject, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

import { DependentsService } from "src/app/services/dependents.service";

import { Dependent } from "src/app/models/dependent";
import { DependentGridList } from "src/app/models/dependent-grid";
import { DependentDialogModel } from "src/app/models/dialog";
import { BenefitWizardType } from "src/app/constants/wizard-panels";
import { EnrollmentBuyupService } from "src/app/services/enrollment-buyup.service";
import { EnrollmentAddService } from "src/app/services/enrollment-add.service";
import { CoverageAddDependent, UnqualifiedDependent } from "src/app/models/coverage-add-dependent";
import { NextPanel } from "src/app/models/next-panel";
import { TobaccoModel, TobaccoPayload } from "src/app/models/tobacco";
import { ListItem } from "src/app/models/listItem";
import { LookupService } from "src/app/services/lookup.service";
import { HelperService } from "src/app/services/helper.service";
import { DbCommon } from "src/app/constants/dbCommon";
import { TableColumn } from "src/app/models/table";
import { TableColumnType } from "src/app/constants/table";
import { MatTableDataSource } from "@angular/material/table";

@Component({
    selector: 'mwp-dialog-dependent',
    templateUrl: './dependent.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DialogDependentComponent implements OnInit {
    public title: string;
    public isNewDependent: boolean;
    public dependent: Dependent;
    public displayForm: boolean;
    public coverageAddDependent: CoverageAddDependent;
    public error: string;
    public displayTobaccoQuestion: boolean;
    public tobaccoModel: TobaccoModel;

    public unqualifiedDependentsMatData: MatTableDataSource<UnqualifiedDependent>;
    public unqualifiedDependentsColumns: TableColumn[] = [{
        columnName: 'Person',
        propertyId: 'name',
        columnType: TableColumnType.label
    },
    {
        columnName: 'Relationship',
        propertyId: 'relationship',
        columnType: TableColumnType.label
    }];

    constructor(
        private dialogRef: MatDialogRef<DialogDependentComponent>,
        private dependentService: DependentsService,
        private enrollmentAddService: EnrollmentAddService,
        private enrollmentBuyupService: EnrollmentBuyupService,
        private lookupService: LookupService,
        private helperService: HelperService,
        @Inject(MAT_DIALOG_DATA) public dependentDialogModel: DependentDialogModel,
    ) {
    }

    ngOnInit(): void {
        this.title = 'Add Dependent';
        this.isNewDependent = true;
        if (this.dependentDialogModel.isWizard) {
            this.unqualifiedDependentsMatData = new MatTableDataSource<UnqualifiedDependent>();
            switch (this.dependentDialogModel.wizardType) {
                case BenefitWizardType.Add:
                    this.enrollmentAddService.getCoverageAddDependent().subscribe((response: CoverageAddDependent) => {
                        this.unqualifiedDependentsMatData.data = response.unqualifiedDependents;
                        this.setNewDependent(response);
                    });
                    break;

                case BenefitWizardType.BuyUp:
                    this.enrollmentBuyupService.getCoverageAddDependent().subscribe((response: CoverageAddDependent) => {
                        this.unqualifiedDependentsMatData.data = response.unqualifiedDependents;
                        this.setNewDependent(response);
                    });
                    break;

                default:
                    this.error = `Wizard type ${this.dependentDialogModel.isWizard} is not Configured`;
                    break;
            }
        }
        else if (this.dependentDialogModel.selectedDependentId && this.dependentDialogModel.selectedDependentId > 0) {
            this.title = 'Edit Dependent';
            this.isNewDependent = false;
            this.dependentService.getDependent(this.dependentDialogModel.selectedDependentId).subscribe((response: Dependent) => {
                this.dependent = response;
                this.displayForm = true;
            });
        } else {
            this.setNewDependent(null);
        }
    }

    private setNewDependent(coverageAddDependent: CoverageAddDependent): void {
        this.coverageAddDependent = coverageAddDependent;
        this.dependent = new Dependent();
        this.displayForm = true;
    }

    public dependentTobaccoQuestion($event: Dependent): void {
        this.dependent = $event;
        this.tobaccoModel = new TobaccoModel;
        this.tobaccoModel.question = this.coverageAddDependent.tobaccoQuestionText;

        let l_Relationship = this.dependent.dependentRelationship;
        this.lookupService.relationships.forEach((li: ListItem) => {
            if (li.value == this.dependent.dependentRelationship)
                l_Relationship = li.text;
        })
        this.tobaccoModel.coveredMembers.items = [{
            systemNumber: null,
            coveredMemberName: `${this.dependent.firstName} ${this.dependent.lastName}`,
            relationship: l_Relationship,
            isSmoker: null,
        }];
        this.tobaccoModel.coveredMembers.items.push();
        this.displayTobaccoQuestion = true;
        this.displayForm = false;
    }

    public tobaccoBack(): void {
        this.displayTobaccoQuestion = false;
        this.displayForm = true;
    }

    public saveTobaccoDependent($event: TobaccoPayload): void {
        this.dependent.smokerStatus = $event.coveredMemberQuestions[0].isSmoker ? 'Y' : 'N';
        this.saveDependent(this.dependent);
    }

    public saveDependent(dependent: Dependent): void {
        const l_Dependent: Dependent = this.helperService.convertObjectIntoObject(dependent, new Dependent());

        if (l_Dependent.id == 0)
            l_Dependent.id = DbCommon.emptyInt;

        if (!l_Dependent.dependentSsn)
            l_Dependent.dependentSsn = '';
        
        if (this.dependentDialogModel.isWizard) {
            switch (this.dependentDialogModel.wizardType) {
                case BenefitWizardType.Add:
                    this.enrollmentAddService.submitCoverageAddDependent(l_Dependent).subscribe((response: NextPanel) => {
                        this.closeDialogResponse(!response ? true : response);
                    });
                    break;

                case BenefitWizardType.BuyUp:
                    this.enrollmentBuyupService.submitCoverageAddDependent(l_Dependent).subscribe((response: NextPanel) => {
                        this.closeDialogResponse(!response ? true : response);
                    });
                    break;

                default:
                    this.error = `Wizard type ${this.dependentDialogModel.isWizard} is not Configured`;
                    break;
            }
        } else {
            this.dependentService.saveDependent(l_Dependent).subscribe((response: DependentGridList[]) => {
                this.closeDialogResponse(response);
            });
        }
    }

    private closeDialogResponse(response: any): void {
        this.dialogRef.close(response);
    }

    public closeDialog() {
        this.dialogRef.close();
    }
}